var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('h2',{staticClass:"card-title"},[_vm._v("Фільтр")])]),_c('v-card-content',[_c('v-text-field',{attrs:{"label":"Ім’я постачальника"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_c('v-card-actions',[_c('v-btn',[_vm._v("Додати фільтр")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }